import React, { useEffect, useMemo, useState } from "react";
import api, { API } from "@/lib/api";
import { PageHeader, Card, Button, Input, Select, Field, Stat, Textarea } from "@/components/UI";
import { Plus, PencilSimple, Trash, ForkKnife, ArrowCounterClockwise, ChefHat, Book, FileXls, Printer } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { today, fmt, rid, EMPTY_RATION, EMPTY_CAT } from "./constants";

export function EventsTab({ events, rations, reload }) {
  const { user } = useAuth();
  const canSeeCosts = !!user?.can_see_costs;
  const [filterRation, setFilterRation] = useState("");

  const undo = async (ev) => {
    if (!window.confirm(`${ev.date} tarihindeki ${ev.ration_name} yemlemesi geri alınsın mı? Düşülen stok miktarları iade edilecek.`)) return;
    try {
      const r = await api.delete(`/rations/events/${ev.id}`);
      toast.success(`Geri alındı, ${r.data.restored_stocks} stok kalemi iade edildi`);
      reload();
    } catch (err) { toast.error(err?.message || "Hata"); }
  };

  const filtered = filterRation ? events.filter(e => e.ration_id === filterRation) : events;
  const totalCost = useMemo(() => filtered.reduce((s, e) => s + Number(e.total_cost || 0), 0), [filtered]);

  return (
    <Card className="!p-0 overflow-hidden">
      <div className="p-4 border-b border-[#E5E2DC] flex items-center justify-between">
        <h3 className="heading text-lg">Yemleme Geçmişi</h3>
        <div className="flex items-center gap-3">
          <Select data-testid="events-filter" value={filterRation} onChange={e => setFilterRation(e.target.value)} className="!py-1 text-xs">
            <option value="">Tüm rasyonlar</option>
            {rations.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
          </Select>
          {canSeeCosts && <span className="text-xs text-[#8a938c]">Toplam: <b className="text-[#C45B45]">{fmt(totalCost, 0)} ₺</b></span>}
        </div>
      </div>
      <table className="data-table">
        <thead>
          <tr>
            <th>Tarih</th>
            <th>Rasyon</th>
            <th className="text-right">Hayvan</th>
            <th className="text-right">Yem Kalemi</th>
            {canSeeCosts && <th className="text-right">Maliyet</th>}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(ev => (
            <tr key={ev.id} data-testid={`event-row-${ev.id}`}>
              <td className="tabnum">{ev.date}</td>
              <td className="font-semibold">{ev.ration_name}</td>
              <td className="text-right tabnum">{ev.animal_count}</td>
              <td className="text-right tabnum">{ev.items?.length || 0}</td>
              {canSeeCosts && <td className="text-right tabnum font-semibold text-[#C45B45]">{fmt(ev.total_cost, 0)} ₺</td>}
              <td className="text-right">
                <button data-testid={`event-undo-${ev.id}`} onClick={() => undo(ev)}
                        className="p-1.5 hover:bg-[#f2ede4] rounded" title="Geri al (stok iade)">
                  <ArrowCounterClockwise size={16} />
                </button>
              </td>
            </tr>
          ))}
          {!filtered.length && <tr><td colSpan={6} className="text-center py-8 text-[#8a938c]">Yemleme kaydı yok</td></tr>}
        </tbody>
      </table>
    </Card>
  );
}

// ---------------- CATALOG TAB ----------------
